import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'gls-modal-promotion',
	templateUrl: 'promotion.component.html',
	styleUrls: ['promotion.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PromotionModalComponent {
	constructor(public activeModal: NgbActiveModal) {}
}
